export enum PreviewImageFormat {
  Big = 'big',
  Medium = 'medium',
  Mobile = 'mobile',
  Small = 'small',
  Wide = 'wide',
}
